import React from 'react';

/**
 * ChannelCardSkeleton — placeholder com shimmer durante loading.
 * Reusa a classe global .dp-skeleton (shimmer + cor de fundo). Mesmo
 * gabarito visual do ChannelCard real pra evitar reflow.
 */
const Box = ({ width, height, radius = 8, style }) => (
  <div
    className="dp-skeleton"
    style={{
      width,
      height,
      borderRadius: radius,
      ...style,
    }}
  />
);

const ChannelCardSkeleton = () => (
  <div
    className="dp-card"
    style={{ padding: 14, display: 'flex', flexDirection: 'column', gap: 12 }}
  >
    {/* Header: avatar + texto */}
    <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
      <Box width={44} height={44} radius={22} />
      <div style={{ flex: 1, display: 'flex', flexDirection: 'column', gap: 6 }}>
        <Box width="70%" height={14} />
        <Box width="40%" height={10} />
      </div>
    </div>

    {/* Faixa de 5 thumbs */}
    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(5, 1fr)', gap: 4 }}>
      {[0, 1, 2, 3, 4].map((i) => (
        <Box key={i} width="100%" height={0} style={{ aspectRatio: '16 / 9' }} radius={6} />
      ))}
    </div>

    {/* Bloco de metricas */}
    <Box width="100%" height={56} radius={10} />

    {/* Footer */}
    <div style={{ display: 'flex', justifyContent: 'space-between', gap: 8 }}>
      <Box width="40%" height={12} />
      <Box width="35%" height={12} />
    </div>
  </div>
);

export default ChannelCardSkeleton;
